// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/clipboard-document-list.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/clipboard-document-list'

import { Icon, type IconComponentProps } from '../icon'

export const ClipboardDocumentListIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
